"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "minerbe": {
    "f3d5a7d0": [{
      "hkey": "c813ed8f",
      "slug": "minerbe",
      "name": "Minerbe",
      "primary": true,
      "skipSearch": false
    }],
    "anson": [{
      "hkey": "c813ed8f",
      "slug": "minerbe",
      "name": "Minerbe",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "aff00687": [{
      "hkey": "c813ed8f",
      "slug": "minerbe",
      "name": "Minerbe",
      "primary": true,
      "skipSearch": false
    }],
    "san-zenone": [{
      "hkey": "c813ed8f",
      "slug": "minerbe",
      "name": "Minerbe",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "15b54ba9": [{
      "hkey": "c813ed8f",
      "slug": "minerbe",
      "name": "Minerbe",
      "primary": true,
      "skipSearch": false
    }],
    "santo-stefano": [{
      "hkey": "c813ed8f",
      "slug": "minerbe",
      "name": "Minerbe",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;